<div #mapElementShadowNorth style="visibility: hidden"></div>
<div #mapElementShadowDoubleBuffer style="visibility: hidden"></div>
<div #mapElement></div>
<ng-container #mapViewContainerRef></ng-container>
